import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
const VIEWER_SEQUENCE = [15, 16, 18, 20];
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 24,
    seconds: 23
  });
  const [viewerIndex, setViewerIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const tick = () => {
      setViewerIndex(prev => (prev + 1) % VIEWER_SEQUENCE.length);
      timeout = setTimeout(tick, 4000 + Math.random() * 3000);
    };
    timeout = setTimeout(tick, 4000 + Math.random() * 3000);
    return () => clearTimeout(timeout);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const viewers = VIEWER_SEQUENCE[viewerIndex];
  return <section className="py-8 md:py-16 px-4 relative overflow-hidden bg-slate-100" data-id="element-34">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-navy rounded p-6 md:p-12 text-center shadow-2xl border-t-4 border-electric relative z-10" data-id="element-35">
        <div className="flex items-center justify-center gap-3 mb-5 md:mb-6" data-id="element-36">
          <span className="text-3xl md:text-4xl animate-bounce" data-id="element-37">⏰</span>
          <h2 className="text-xl md:text-3xl font-black text-white uppercase tracking-wider leading-tight" data-id="element-38">
            EL PRECIO DE <br className="md:hidden" data-id="element-39" /> LANZAMIENTO TERMINA EN:
          </h2>
        </div>

        <div className="flex justify-center items-center gap-4 md:gap-8 mb-6 md:mb-8" data-id="element-40">
          {[{
          val: timeLeft.hours,
          label: 'HS'
        }, {
          val: timeLeft.minutes,
          label: 'MIN'
        }, {
          val: timeLeft.seconds,
          label: 'SEG'
        }].map((item, i) => <Fragment key={i} data-id="element-41">
              <div className="flex flex-col items-center bg-slate-800 p-4 md:p-6 rounded border border-slate-700 min-w-[80px] md:min-w-[120px]" data-id="element-42">
                <span className="text-5xl md:text-7xl font-black text-electric tabular-nums" data-id="element-43">
                  {formatNumber(item.val)}
                </span>
                <span className="text-xs md:text-sm font-bold text-slate-400 uppercase mt-2 tracking-widest" data-id="element-44">
                  {item.label}
                </span>
              </div>
              {i < 2 && <span className="text-4xl md:text-6xl font-black text-slate-600 mb-8 animate-pulse" data-id="element-45">
                  :
                </span>}
            </Fragment>)}
        </div>

        <div className="max-w-lg mx-auto bg-slate-800 p-6 rounded border border-slate-700" data-id="element-46">
          <div className="flex justify-between items-end mb-3" data-id="element-47">
            <div className="flex items-center gap-2" data-id="element-48">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" data-id="element-49" />
              <span className="text-[10px] md:text-xs font-bold text-slate-400 uppercase tracking-widest" data-id="element-50">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-[10px] md:text-xs font-bold text-white uppercase bg-red-500/20 text-red-400 px-2 py-1 rounded" data-id="element-51">
              Quedan pocos
            </span>
          </div>
          <div className="h-4 bg-slate-900 rounded overflow-hidden mb-3 border border-slate-700" data-id="element-52">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '80%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-electric rounded relative overflow-hidden" data-id="element-53">
              <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(0,0,0,0.1)_50%,transparent_75%,transparent_100%)] bg-[length:20px_20px] animate-[shimmer_1s_linear_infinite]" data-id="element-54"></div>
            </motion.div>
          </div>
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-6" data-id="element-55">
            80% de los cupos tomados
          </p>

          {/* LIVE VIEWERS */}
          <div className="inline-flex items-center gap-3 bg-slate-900 border border-slate-700 rounded px-4 py-2" data-id="element-56">
            <span className="relative flex h-3 w-3" data-id="element-57">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-58" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-59" />
            </span>
            <span className="text-xs md:text-sm font-semibold text-slate-300" data-id="element-60">
              <span className="text-lg mr-1" data-id="element-61">👀</span>
              <motion.span key={viewers} initial={{
              opacity: 0,
              y: -4
            }} animate={{
              opacity: 1,
              y: 0
            }} className="inline-block text-white font-black tabular-nums mx-1 text-electric" data-id="element-62">
                {viewers}
              </motion.span>{' '}
              técnicos viendo en este momento
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}